// Core
import styled from 'styled-components';

export const Element = styled.div`
  width: 100%;
  height: 100%;
`;
